import { useState } from "react";
import { useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { useCheckAuth } from "../api/effects/mutations/checkAuth";
import LoadingScreen from "../components/LoadingScreen";
import UserState from "../recoil/UserState";
import { eraseCookie, getCookie } from "../utils/cookies";

interface IAuthProps {
  role: string[];
}

const RequireAuth = (props: IAuthProps) => {
  const token = getCookie("token");

  const setRecoil = useSetRecoilState(UserState);
  const removeRecoil = useResetRecoilState(UserState);
  const recoilValue = useRecoilValue(UserState);

  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  const eraseRecoil = async () => {
    removeRecoil();
  };

  const eraseAuthCookie = async () => {
    eraseCookie("token");
  };

  // API
  const { mutateAsync: checkAuth } = useCheckAuth({
    onSuccess(data) {
      setRecoil(data);
      setIsLoading(false);
    },
    onError() {
      eraseAuthCookie()
        .then(eraseRecoil)
        .then(() => navigate("/", { replace: true }));
      alert("Session Timed Out");
    },
  });

  useEffect(() => {
    if (token !== null) checkAuth({});
    else {
      navigate("/Login", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const location = useLocation();

  if (isLoading) {
    return <LoadingScreen open={isLoading} />;
  }

  // return props.role.includes(recoilValue?.ROLE) ? (
  //   <Outlet />
  // ) : recoilValue ? (
  //   <Navigate to="unauthorized" state={{ from: location }} replace />
  // ) : (
  //   <Navigate to="/" state={{ from: location }} replace />
  // );

  return recoilValue ? (
    props.role.includes(recoilValue.ROLE) ? (
      <Outlet />
    ) : (
      <Navigate to="/" state={{ from: location }} replace />
    )
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export default RequireAuth;
